import { getApi } from "../api";
import { encryptdata } from "../../../utils/encryptDecrypt";

export const getAllBusinessApi = () => getApi(`/user/subscription-business/${encryptdata(5)}`);
// export const getAllBusinessApi = () => getApi(`/user/list-business`);
